import { Modal } from "antd";
import { get } from "lodash";
import { useMemo } from "react";

const PriceChangeModal = ({
  visible,
  priceComparison,
  onConfirm,
  onCancel,
  loading,
  cancelling = false,
  ButtonComponent,
}) => {
  // Calculate prices using the same logic as the cart
  // Cart: upsells.reduce((acc, { cost }) => (acc += cost), get(generalCost, "cost", 0))
  const currentTotal = useMemo(() => {
    if (!priceComparison) return 0;
    const generalCost = priceComparison.currentGeneralCost;
    const upsells = priceComparison.currentUpsells || [];
    const generalCostAmount = get(generalCost, "cost", 0);
    const upsellsAmount = upsells.reduce((acc, upsell) => {
      return acc + (get(upsell, "cost", 0) || 0);
    }, 0);
    return generalCostAmount + upsellsAmount;
  }, [priceComparison]);

  const newTotal = useMemo(() => {
    if (!priceComparison) return 0;
    const generalCost = priceComparison.newGeneralCost;
    const upsells = priceComparison.newUpsells || [];
    const generalCostAmount = get(generalCost, "cost", 0);
    const upsellsAmount = upsells.reduce((acc, upsell) => {
      return acc + (get(upsell, "cost", 0) || 0);
    }, 0);
    return generalCostAmount + upsellsAmount;
  }, [priceComparison]);

  const totalPriceDiff = useMemo(() => {
    return newTotal - currentTotal;
  }, [currentTotal, newTotal]);

  const hasPriceChange = Math.abs(totalPriceDiff) > 0.01;

  if (!ButtonComponent) {
    console.error("PriceChangeModal: ButtonComponent prop is required");
    return null;
  }

  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
      className="price-change-modal"
      wrapClassName="price-change-modal__wrapper"
      closable={false}
      maskClosable={false}
    >
      <div className="price-change-modal__content">
        <h2 className="price-change-modal__title">
          Changement de prix détecté
        </h2>
        <p className="price-change-modal__description">
          Le changement d'année de la date d'effet affecte les prix. Voici le
          récapitulatif des modifications :
        </p>

        <div className="price-change-modal__comparison">
          <div className="price-change-modal__section">
            <div className="price-change-modal__price-row">
              <span>Prix actuel :</span>
              <span className="price-change-modal__current-price">
                {currentTotal.toFixed(2)} €
              </span>
            </div>
            <div className="price-change-modal__price-row">
              <span>Nouveau prix :</span>
              <span className="price-change-modal__new-price">
                {newTotal.toFixed(2)} €
              </span>
            </div>
            <div className="price-change-modal__price-row">
              <strong>Différence :</strong>
              <strong
                className={`price-change-modal__diff ${
                  totalPriceDiff > 0 ? "positive" : "negative"
                }`}
              >
                {totalPriceDiff > 0 ? "+" : ""}
                {totalPriceDiff.toFixed(2)} €
              </strong>
            </div>
          </div>

          {!hasPriceChange && (
            <div className="price-change-modal__no-change">
              Aucun changement de prix détecté.
            </div>
          )}
        </div>

        <div className="price-change-modal__actions">
          <ButtonComponent
            type="default"
            onClick={async () => {
              if (!loading && !cancelling) {
                await onCancel();
              }
            }}
            disabled={loading || cancelling}
            loading={cancelling}
            alignment="center"
            className="price-change-modal__action-button"
          >
            {cancelling ? "Annulation en cours..." : "Annuler"}
          </ButtonComponent>
          <ButtonComponent
            type="primary"
            onClick={async () => {
              if (!loading && !cancelling) {
                await onConfirm();
              }
            }}
            disabled={loading || cancelling}
            loading={loading}
            alignment="center"
            className="price-change-modal__action-button"
          >
            {loading ? "Calcul en cours..." : "Confirmer le changement"}
          </ButtonComponent>
        </div>
      </div>
    </Modal>
  );
};

export default PriceChangeModal;
